// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W4Sx","delete":"styles_delete__36OPE","update":"styles_update__3HUdk","add":"styles_add__2E0-A"};